/**
 * @deprecated This component is no longer used on mobile.
 * The close/back action is now handled by the MobileSidebar header.
 * This component only exists for backwards compatibility and returns null.
 */
function MobileSessionBarPanelCloseButton() {
  // On mobile, the close/back action is now in the MobileSidebar header.
  // This component is kept for backwards compatibility but no longer renders anything.
  return null;
}

export default MobileSessionBarPanelCloseButton;
